<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <div class="d-inline-block" style="max-width: 300px">
              <v-select
                v-model="estadoInscripcion"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Preinscrito', value: estadosInscripcionesEnum.PREINSCRITO },
                  { text: 'Inscrito', value: estadosInscripcionesEnum.INSCRITO },
                  { text: 'Retirado', value: estadosInscripcionesEnum.RETIRADO },
                  { text: 'Cambiado', value: estadosInscripcionesEnum.CAMBIADO },
                  { text: 'Congelado', value: estadosInscripcionesEnum.CONGELADO },
                ]"
                label="Estado inscripción"
                outlined
                dense
                hide-details
                @change="listar"></v-select>
            </div>
          </v-col>

          <v-col cols="12">
            <ListadoInscripciones
              ref="listadoRef"
              :items="items"
              :cargando="cargando"
              :itemsYaSeleccionados="itemsYaSeleccionados"
              :itemsYaSolicitados="detallesSolicitudesInscripcionesYaSolcitados"
              :itemsYaInscritos="inscritosProgramaUniversidad"
              :mostrarColumnaSolicitado="true"
              :universidadId="universidadId"
              @selectItem="selectItem" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || itemsSeleccionados.length == 0"
          :loading="enviando"
          @click.prevent="agregarDetallesSolicitudesInscripciones">
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import layoutMixin from '../mixins/layout.mixin';
import ListadoInscripciones from './ListadoInscripciones.vue';
import InscripcionesService from '../services/inscripcion.service';
import { ESTADOS_INCRIPCIONES_ENUM } from '../utils/constantes';
import { mapGetters } from 'vuex';
import SolicitudInscripcionService from '../services/solicitud-inscripcion.service';
import InscripcionProgramaUniversidadService from '../services/inscripcion-programa-universidad.service';

export default {
  name: 'ModalInscripciones',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoInscripciones,
  },
  props: {
    programaUniversidadId: {
      type: Number,
      default: null,
    },
    universidadId: {
      type: Number,
      default: null,
    },
    programaId: {
      type: Number,
      required: true,
    },
    itemsYaSeleccionados: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemsSeleccionados: [],
      estadoInscripcion: ESTADOS_INCRIPCIONES_ENUM.INSCRITO,
      estadosInscripcionesEnum: ESTADOS_INCRIPCIONES_ENUM,
      solicitudesInscripcionesRealizadas: [],
      inscritosProgramaUniversidad: [],
    };
  },
  computed: {
    ...mapGetters('pago', ['getFiltrarPorSede']),
    detallesSolicitudesInscripcionesYaSolcitados() {
      return this.solicitudesInscripcionesRealizadas
        .map((solicitudInscripcion) => solicitudInscripcion.detallesSolicitudesInscripciones)
        .flat();
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
      };
    },
    abrir(accion, data = []) {
      this.itemsSeleccionados = [];
      this.abrirMixin(accion, data);
      this.obtenerSolicitudesInscripcionesRealizadas();
      this.obtenerInscritosProgramaUniverdidad();
      this.listar();
    },
    listar() {
      const params = {
        programaId: this.programaId,
        universidadId: this.universidadId,
        estadoInscripcion: this.estadoInscripcion,
      };

      this.obtenerDatosConNotificacion(
        InscripcionesService.findAllPorProgramaSedeVerificacion,
        'items',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    selectItem(items) {
      this.itemsSeleccionados = items || [];
    },
    agregarDetallesSolicitudesInscripciones() {
      this.$emit('agregarDetallesSolicitudesInscripciones', this.itemsSeleccionados);
      this.cerrar();
    },
    obtenerSolicitudesInscripcionesRealizadas() {
      const params = {
        programaId: this.programaId,
      };

      this.solicitudesInscripcionesRealizadas = [];

      this.obtenerDatosMixin(
        SolicitudInscripcionService.findAll,
        'solicitudesInscripcionesRealizadas',
        params,
        () => {},
        () => {
          this.itemsSeleccionados = [];
        },
      );
    },
    async obtenerInscritosProgramaUniverdidad() {
      this.inscritosProgramaUniversidad = [];

      if (!this.programaUniversidadId) return;

      await this.obtenerDatosMixin(InscripcionProgramaUniversidadService.findAll, 'inscritosProgramaUniversidad', {
        programaUniversidadId: this.programaUniversidadId,
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>